import React from "react";

import ApplyButton, { ApplyButtonProps } from "./ApplyButton";

export default function SecondaryApplyButton(props: ApplyButtonProps) {
    return <ApplyButton {...props} customClass={`secondary-action-button ${props.customClass}`} />;
}
